import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import getColorByRating from '@utils/review/getColorByRating';
import messages from '../messages';

const RatingDetail = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.xxSmallBold}
  line-height: 1.45;
  letter-spacing: 0;
  color: ${({ value }) => getColorByRating(value)?.textColor};
  padding-right: 3%;
`;

const Container = styled.div`
  padding-top: 1vh;
`;

function ReviewCardRatings({ speed, service, food }) {
  return (
    <Container>
      <FormattedMessage {...messages.speed} values={{ speed }}>
        {text => <RatingDetail value={speed}>{text}</RatingDetail>}
      </FormattedMessage>
      <FormattedMessage {...messages.food} values={{ food }}>
        {text => <RatingDetail value={food}>{text}</RatingDetail>}
      </FormattedMessage>
      <FormattedMessage {...messages.service} values={{ service }}>
        {text => <RatingDetail value={service}>{text}</RatingDetail>}
      </FormattedMessage>
    </Container>
  );
}

ReviewCardRatings.propTypes = {
  speed: PropTypes.number.isRequired,
  food: PropTypes.number.isRequired,
  service: PropTypes.number.isRequired,
};

export default ReviewCardRatings;
